const binding = { modules: {}, dataActions: {} };

    (binding.modules['page-header'] = {
        c: () => require('partner/modules/page-header/page-header.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'page-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/page-header'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|page-header|page-header'] = {
                c: () => require('partner/modules/page-header/page-header.view.tsx'),
                cn: '__local__-__local__-page-header'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };